import { render } from "./QueueList.vue?vue&type=template&id=72034308&scoped=true"
import script from "./QueueList.vue?vue&type=script&lang=js"
export * from "./QueueList.vue?vue&type=script&lang=js"

import "./QueueList.vue?vue&type=style&index=0&id=72034308&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72034308"]])

export default __exports__